// Real publications data from chaturvedilab.org

// Manuscripts in preparation
export const manuscriptsInPreparation = [
  {
    id: "prep1",
    title: "A Streamlined Protocol to Model Cytomegalovirus Latency Establishment in Myeloid Progenitor Cells",
    authors: "Shenoy et al.",
    status: "under revision"
  },
  {
    id: "prep2",
    title: "scTRACER: Modeling Transcriptional Decision Logic at Single Cell Resolution",
    authors: "Shaik et al.",
    status: "in preparation"
  },
  {
    id: "prep3",
    title: "qLATTE: Quantum Latent Analysis with Temporal Pattern and Trajectory Preserving Embeddings for Single Cells",
    authors: "Bhardwaj et al.",
    status: "in preparation"
  }
];

export const realPublications = [
  {
    id: 21,
    title: "Therapeutic Interfering Particles (TIPs): Escape-Resistant Antiviral Against SARS-CoV-2",
    authors: "Chaturvedi S",
    journal: "Physical Virology: From the State-of-the-Art Research to the Future of Applied Virology",
    year: 2023,
    pmid: "37000000",
    featured: false
  },
  {
    id: 20,
    title: "Disrupting autorepression circuitry generates 'open-loop lethality' to yield escape-resistant antiviral agents",
    authors: "Chaturvedi et al.",
    journal: "Cell",
    year: 2022,
    pmid: "35561685",
    featured: true,
    note: "co-corresponding author"
  },
  {
    id: 19,
    title: "A single-administration therapeutic interfering particle reduces SARS-CoV-2 viral shedding and pathogenesis in hamsters",
    authors: "Chaturvedi et al.",
    journal: "PNAS",
    year: 2022,
    pmid: "36074824",
    featured: true
  },
  {
    id: 18,
    title: "Identification of a Therapeutic Interfering Particle — a single-administration SARS-CoV-2 antiviral with a high barrier to the evolution of resistance",
    authors: "Chaturvedi et al.",
    journal: "Cell",
    year: 2021,
    pmid: "34838159",
    featured: true,
    note: "co-corresponding author"
  },
  {
    id: 17,
    title: "A DNA repair pathway can regulate transcriptional noise to promote cell fate transitions",
    authors: "Desai RV, Chen X, Martin B, Chaturvedi S et al.",
    journal: "Science",
    year: 2021,
    pmid: "34301855",
    featured: true
  },
  {
    id: 16,
    title: "A molecular mechanism for probabilistic bet hedging and its role in viral latency",
    authors: "Chaturvedi et al.",
    journal: "PNAS",
    year: 2020,
    pmid: "32632017",
    featured: true
  },
  {
    id: 15,
    title: "The HSV-1 ICP4 transcriptional auto-repression circuit functions as a transcriptional 'accelerator' circuit",
    authors: "Chaturvedi et al.",
    journal: "Frontiers in Cellular and Infection Microbiology",
    year: 2020,
    pmid: "32670890",
    featured: false
  },
  {
    id: 14,
    title: "Studying RNA-Protein Interaction using Riboproteomics",
    authors: "Chaturvedi et al.",
    journal: "Methods in Molecular Biology: RNA Analysis",
    year: 2019,
    pmid: "32797461",
    featured: false
  },
  {
    id: 13,
    title: "Feedback-mediated signal conversion promotes viral fitness",
    authors: "Vardi N, Chaturvedi et al.",
    journal: "PNAS",
    year: 2018,
    pmid: "30150429",
    featured: false
  },
  {
    id: 12,
    title: "Molecular and biological factors regulating the genome packaging in single-strand positive-sense tripartite RNA plant viruses",
    authors: "Chaturvedi et al.",
    journal: "Current Opinion in Virology",
    year: 2018,
    pmid: "30165268",
    featured: false
  },
  {
    id: 11,
    title: "Riboproteomics: A versatile approach for the identification of host protein interaction network in noncoding RNAs",
    authors: "Chaturvedi et al.",
    journal: "PLoS One",
    year: 2017,
    pmid: "29073276",
    featured: false
  },
  {
    id: 10,
    title: "Functionality of host proteins in Cucumber mosaic virus replication: GAPDH is obligatory to promote interaction between replication-associated proteins",
    authors: "Chaturvedi et al.",
    journal: "Virology",
    year: 2016,
    pmid: "27077230",
    featured: false
  },
  {
    id: 9,
    title: "A shift in plant proteome profile for Bromodomain containing RNA binding Protein (BRP1) in plants infected with Cucumber mosaic virus and its satellite RNA",
    authors: "Chaturvedi et al.",
    journal: "Journal of Proteomics",
    year: 2016,
    pmid: "26463137",
    featured: false
  },
  {
    id: 8,
    title: "Live cell imaging of interactions between replicase and capsid protein of Brome Mosaic Virus using bimolecular fluorescence complementation",
    authors: "Chaturvedi et al.",
    journal: "Virology",
    year: 2014,
    pmid: "25046269",
    featured: false
  },
  {
    id: 7,
    title: "Integration of replication and assembly of infectious virions in plant RNA viruses",
    authors: "Rao ALN, Chaturvedi S and Garmann R",
    journal: "Current Opinion in Virology",
    year: 2014,
    pmid: "25308094",
    featured: false
  },
  {
    id: 6,
    title: "Repair of the 3' proximal and internal deletions of a satellite RNA associated with Cucumber mosaic virus is directed toward restoring structural integrity",
    authors: "Kwon SJ, Chaturvedi S and Rao ALN",
    journal: "Virology",
    year: 2014,
    pmid: "24503085",
    featured: false,
    note: "Equal contribution"
  },
  {
    id: 5,
    title: "A bromodomain containing host protein mediates the nuclear import of a satellite RNA of cucumber mosaic virus",
    authors: "Chaturvedi et al.",
    journal: "Journal of Virology",
    year: 2014,
    pmid: "24284314",
    featured: false,
    note: "Selected for JVI Spotlight"
  },
  {
    id: 4,
    title: "Mutations in the capsid protein of brome mosaic virus affecting encapsidation eliminate vesicle induction in planta",
    authors: "Bamunusinghe D, Chaturvedi S, Seo JK and Rao ALN",
    journal: "Journal of Virology",
    year: 2013,
    pmid: "23741003",
    featured: false
  },
  {
    id: 3,
    title: "Functional significance of a hepta nucleotide motif present at the junction of cucumber mosaic virus satellite RNA multimers in helper-virus-dependent replication",
    authors: "Seo JK, Kwon SJ, Chaturvedi S and Rao ALN",
    journal: "Virology",
    year: 2013,
    pmid: "23146208",
    featured: false
  },
  {
    id: 2,
    title: "A simple and robust in vivo and in vitro approach for studying assembly in RNA viruses",
    authors: "Chaturvedi et al.",
    journal: "Journal of Visualization Experiment",
    year: 2012,
    pmid: "22410612",
    featured: false
  },
  {
    id: 1,
    title: "Packaging and structural phenotype of brome mosaic virus capsid protein with altered N terminal β-hexamer structure",
    authors: "de Wispelaere M, Chaturvedi S, Wilkens S and Rao ALN",
    journal: "Virology",
    year: 2011,
    pmid: "21864876",
    featured: false,
    note: "Featured on cover page"
  }
];
